import AOS from "aos";
import "aos/dist/aos.css";
import ReactDOM from "react-dom/client";
import "./styles/MarketFusion.css";
import { setPrefix } from "./lib/bandung/bandung";
import App from "./App";

// setPrefix("http://localhost:5000/https://startup4.ipserlab.com");
// setPrefix("http://localhost:5000/https://www.marketfusion.com"); // Uncomment to work with production server
// setPrefix("http://localhost:5000/http://localhost:8080") ; // Uncomment to work with local server

AOS.init();
ReactDOM.createRoot(document.getElementById("root")).render(<App/>);